export const areArraysEqual = (arr1:any[], arr2:any[]) => {
    if (arr1.length !== arr2.length) return false;
    
    const countMap = new Map();
    
    for (const item of arr1) {
      countMap.set(item, (countMap.get(item) || 0) + 1);
    }
    
    for (const item of arr2) {
      if (!countMap.has(item)) return false;
      countMap.set(item, countMap.get(item) - 1);
      if (countMap.get(item) === 0) countMap.delete(item);
    }
    
    return countMap.size === 0;
  };